import React, { Component } from 'react'
import { Consumer } from './container'

export const asASlide = ({ position = 1 } = {}) => (WrappedComponent) =>
  class Slide extends Component {
    renderSlide = (slide) =>
      slide.position === position ? (
        <WrappedComponent slide={slide} {...this.props} />
      ) : null

    render = () => <Consumer>{this.renderSlide}</Consumer>
  }

export default asASlide
